import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';

@Component({
    selector: 'gwc-frontend-multi-gown-select-dialog',
    templateUrl: './multi-gown-select-dialog.component.html',
    styleUrls: ['./multi-gown-select-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent]
})
export class MultiGownSelectDialogComponent implements OnInit {

    constructor(
		private _matDialogRef: MatDialogRef<MultiGownSelectDialogComponent>
	) { }

    ngOnInit(): void {
    }



	public degreeSelected(degree: string) {

		this._matDialogRef.close(degree);
		
	}


}
